import React from 'react'
import classNames from 'classnames'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import Autocomplete, { AutocompleteProps } from '@material-ui/lab/Autocomplete'
import { useTranslation } from 'react-i18next'

import classes from './AutocompleteSelect.scss'

type AutocompletePropsOurs = AutocompleteProps<{}, undefined, undefined, undefined>;

export type AutocompleteSelectProps = Omit<AutocompletePropsOurs, 'onChange'>
  & Pick<TextFieldProps, 'label' | 'error' | 'helperText' | 'autoFocus' | 'margin' | 'InputLabelProps'>
  & {
    suggestions: AutocompletePropsOurs['options'],
    isClearable: boolean,
    onType: () => void,
    onChange: (value: string | {}) => void
  }

export default function AutocompleteSelect({
  suggestions,
  onChange,
  value,
  label,
  classes: classesProp,
  isClearable,
  onType,
  disabled,
  error,
  helperText,
  loading,
  getOptionLabel,
  getOptionSelected,
  onOpen,
  onClose,
  autoFocus,
  margin,
  InputLabelProps,
  ...rest
}: Partial<AutocompleteSelectProps>): JSX.Element {
  const { t } = useTranslation(['main'])

  return (
    <Autocomplete
      options={suggestions}
      classes={{
        ...classesProp,
        popupIndicator: classNames(classes.popupIndicator, classesProp?.popupIndicator),
      }}
      disableClearable={!isClearable}
      getOptionLabel={getOptionLabel ?? (option => (option as { label: string }).label)}
      getOptionSelected={getOptionSelected}
      onChange={(evt, value) => onChange(value)}
      onInputChange={onType}
      noOptionsText={t('no_results_found')}
      value={value}
      disabled={disabled}
      loading={loading}
      openText={t('main:buttons.open')}
      closeText={t('main:buttons.close')}
      loadingText={t('main:loading')}
      renderInput={params => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          variant="standard"
          label={label}
          error={error}
          helperText={helperText}
          margin={margin}
          InputLabelProps={InputLabelProps}
          fullWidth
        />
      )}
      {...rest}
    />
  )
}
